













import vue from "vue";
import { SessionDetails } from "@tt-app/store/terratalkLive/types";
import { dateTimeStringToLocaleString, parseDate } from "@tt-app/utils";

interface Computed {
  endTime: string;
  groupName: string;
  startTime: string;
  sessionIsUpcoming: boolean;
}

interface Props {
  sessionDetails: SessionDetails;
}

export default vue.extend<any, any, Computed, Props>({
  name: "TerratalkLiveSessionActive",

  props: {
    sessionDetails: {
      type: Object as () => SessionDetails,
      default: undefined
    }
  },

  computed: {
    endTime() {
      return dateTimeStringToLocaleString(this.sessionDetails?.endsAt) || "";
    },

    groupName() {
      return this.sessionDetails?.group.name || "";
    },

    sessionIsUpcoming() {
      const now = new Date();
      const startsAt = parseDate(this.sessionDetails?.startsAt);
      return startsAt ? startsAt > now : false;
    },

    startTime() {
      return dateTimeStringToLocaleString(this.sessionDetails?.startsAt) || "";
    }
  }
});
